// This file can be replaced during build by using the `fileReplacements` array.
// `ng build ---prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

import { constants } from "buffer";

export const environment = {
  production: false,  
  baseUrlLocal:'https://localhost:44340/',
  baseUrlDev:'https://sigma.wshaudit-dev-dmz.prj.gcp.wellsky.io/',
  version: require('../../package.json').version
};

export const genericsError = {
  limitRecordsErrorHttp: "400",
  limitErrorRecordsTable: "500000",
  limitFilterData:"500",
  connectionData:"0",
  pageSize: "50"
}

/*
 * In development mode, to ignore zone related error stack frames such as
 * `zone.run`, `zoneDelegate.invokeTask` for easier debugging, you can
 * import the following file, but please comment it out in production mode
 * because it will have performance impact when throw error
 */
// import 'zone.js/dist/zone-error';  // Included with Angular CLI.
